import { render } from "./BusDetails.vue?vue&type=template&id=5f4ba3aa&scoped=true"
import script from "./BusDetails.vue?vue&type=script&lang=js"
export * from "./BusDetails.vue?vue&type=script&lang=js"

import "./BusDetails.vue?vue&type=style&index=0&id=5f4ba3aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4ba3aa"]])

export default __exports__